import * as React from 'react';
import SvgIcon, { SvgIconProps } from './SvgIcon';

const TravelIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props}>
      <path d="M16.4623 31.8938L20.5876 41.2546H47.9688" stroke={props.htmlColor || "black"} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M11.8345 31.9053L17.818 45.0758H48.1675L50.2009 49.5751" stroke={props.htmlColor || "black"} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M17.7946 45.0757L15.7378 49.5749" stroke={props.htmlColor || "black"} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M16.2403 6.97827C16.2403 6.97827 31.8416 8.08848 34.0503 10.4024C35.3943 11.8164 37.2057 14.9016 37.2057 14.9016L7.19502 27.4879C7.19502 27.4879 6.26011 24.0404 6.20168 22.0888C6.10819 18.8867 16.2403 6.97827 16.2403 6.97827Z" fill={props.htmlColor || "#FFCB06"} stroke={props.htmlColor || "#FFCB06"} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M16.2403 6.97808L15.7378 5.7627" stroke={props.htmlColor || "#FFCB06"} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M22.212 21.2004L30.6379 41.2543" stroke={props.htmlColor || "#FFCB06"} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M32.2272 45.0757L33.8867 48.8621" stroke={props.htmlColor || "#FFCB06"} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    </SvgIcon>
  );
};

export default TravelIcon;
